import { Places } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'

export class MensagemDiretaKeys extends MainKeys {
    public get place() {
        return Places.mensagemDireta
    }
}

export default MensagemDiretaKeys
